import { useState } from 'react'
import { OptionalTwilioNumber, RegisteredTwilioNumber } from 'interfaces/db'
import { UserDataResult } from "interfaces/users"
import { getServicesManager } from 'services'

interface UsePurchasingResult {
  purchasingNumbers: string[]
  purchaseNumber: (
    number: OptionalTwilioNumber,
    user: UserDataResult,
    countryCode: string,
    numberType: 'Local' | 'Mobile' | 'TollFree',
    isAdmin?: boolean
  ) => Promise<boolean>
}

export function usePurchasing(
  selectedNumbers: RegisteredTwilioNumber[],
  setSelectedNumbers: (numbers: RegisteredTwilioNumber[]) => void
): UsePurchasingResult {
  const [purchasingNumbers, setPurchasingNumbers] = useState<string[]>([])

  const purchaseNumber = async (
    number: OptionalTwilioNumber,
    user: UserDataResult,
    countryCode: string,
    numberType: 'Local' | 'Mobile' | 'TollFree',
    isAdmin?: boolean
  ): Promise<boolean> => {
    setPurchasingNumbers(prev => [...prev, number.phone_number])
    try {
      const registerdNumberOrError = isAdmin
        ? await getServicesManager().acquireTwilioNumberAdmin(
            number.phone_number,
            user.user_id,
            countryCode,
            numberType
          )
        : await getServicesManager().registerTwilioNumber(
            number,
            countryCode,
            numberType
          )

      if (typeof registerdNumberOrError === 'string') {
        setPurchasingNumbers(prev => prev.filter(n => n !== number.phone_number))
        alert(registerdNumberOrError)
        return false
      } else {
        setSelectedNumbers([...selectedNumbers, registerdNumberOrError])
        return true
      }
    } catch (error) {
      console.error('Error purchasing number:', error)
      alert(`Unexpected error purchasing ${number.phone_number}.`)
      return false
    } finally {
      setPurchasingNumbers(prev => prev.filter(n => n !== number.phone_number))
    }
  }

  return {
    purchasingNumbers,
    purchaseNumber
  }
}
